'use client'

import { QuirksConfig } from '@quirks/react'
import type { ReactNode } from 'react'
import { getConfig } from './quirks'

interface CosmosProviderProps {
  children: ReactNode
  quirksCookie?: string
}

export function CosmosProvider({
  children,
  quirksCookie,
}: CosmosProviderProps) {
  return <QuirksConfig store={getConfig(quirksCookie)}>{children}</QuirksConfig>
}
